import './LiveReviewFeed.scss';

import React, {useEffect, useState} from 'react';
import {Review, ReviewService} from "../../services/api/ReviewService";
import {handicaddieSelector} from "../../services/store/asyncThunk";
import CaddieReview from "./CaddieReview";
import ErrorText from "../ErrorText";

interface Props {

}

const LiveReviewFeed = ({}: Props) => {

    const [reviews, setReviews] = useState<Review[]>([]);
    const [errMsg, setErrMsg] = useState<string>();

    const [lastReceived, setLastReceived] = useState<Date>();
    const [checks, setChecks] = useState<number>(0);
    const [polls, setPolls] = useState<number>(0);
    const [lastReceivedTxt, setLastReceivedTxt] = useState<string>("Not yet updated.");

    const { searchReviews } = ReviewService()
    const { selectedClub } = handicaddieSelector((state) => state.clubs)

    useEffect(() => {
        const intervalId = setInterval(() => {
            setChecks(checks => {
                return checks + 1
            })
        }, 66000) // 1 minute, 6 seconds

        const intervalId2 = setInterval(() => {
            setPolls(polls => {
                return polls + 1
            })
        }, 300000) // 5 minutes

        // Create function to clean up the interval when the component unmounts.
        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
            if (intervalId2) {
                clearInterval(intervalId2);
            }
        }
    }, []);

    useEffect(() => {
        analyseLastReceived()
    }, [lastReceived, checks]);

    useEffect(() => {
        if (!selectedClub) {
            return;
        }

        loadReviews()
    }, [selectedClub, polls])

    const loadReviews = async () => {
        if (!selectedClub) {
            return;
        }

        setErrMsg(undefined);

        let resp = await searchReviews({
            clubId: selectedClub.id,
            page: 0,
            size: 10
        })
        if (resp.error) {
            setErrMsg(resp.error.message);
            return;
        }

        console.log(resp)

        if (resp.page?.resource) {
            setReviews(resp.page.resource)
            setLastReceived(new Date())
        }
    }

    const analyseLastReceived = () => {
        if (!lastReceived) {
            return;
        }

        let diff: number = new Date().getTime() - lastReceived.getTime();
        let mins = Math.round(((diff % 86400000) % 3600000) / 60000);


        if (mins < 1) {
            setLastReceivedTxt('Just now.')
        } else if (mins === 1) {
            setLastReceivedTxt(mins + ' minute ago.')
        } else {
            setLastReceivedTxt(mins + ' minutes ago.')
        }

    }

    return (
        <div className={"dashboard-feed-container"}>
            <div>
                <h6>Live Review Feed</h6>
                <p>Last updated: {lastReceivedTxt}</p>
            </div>

            {errMsg && <ErrorText>{errMsg}</ErrorText>}
            {reviews.map((review) => <CaddieReview review={review} />)}
            {(!reviews || reviews.length === 0) && (<div className={"dashboard-feed-no-reviews"}>
                <i>No reviews to display.</i>
            </div>)}
        </div>
    )
}

export default LiveReviewFeed;